<wb-spinner class="centered-element" theme="light" style="width: 128px; height: 128px"></wb-spinner>